import React from 'react'

const StoriesFeatures = () =>
  <div className="page feature">
    <h1>Stories</h1>
  </div>

export default StoriesFeatures
